import Bugsnag, { OnErrorCallback } from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import getConfig from "next/config"

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig()

const apiKey = serverRuntimeConfig.BUGSNAG_API_KEY || publicRuntimeConfig.BUGSNAG_API_KEY

/**
 * Discard errors originating from Google Translate proxied pages.
 * Google Translate serves our site under *.translate.goog domains. Bugsnag's
 * Allowed Domains config only checks the reporting domain, not the page URL,
 * so translate.goog events bypass that filter and create significant noise.
 * Returning false tells Bugsnag to drop the event entirely.
 */
const onError: OnErrorCallback = (event) => {
  const url = event.request?.url ?? ""
  if (url.includes(".translate.goog")) return false
}

if (apiKey) {
  Bugsnag.start({
    apiKey,
    appVersion: publicRuntimeConfig.GIT_COMMIT,
    releaseStage: publicRuntimeConfig.APP_ENV,
    enabledReleaseStages: ["staging", "production"],
    collectUserIp: false,
    plugins: [new BugsnagPluginReact()],
    onError,
  })
}

export { Bugsnag }
